export const isCalendarDateBeforeToday = (date: Date, today = new Date()) => {
  const calendarDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const currentCalendarDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  return calendarDate < currentCalendarDate;
};
